import { useContext, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";

import SiteTitle from "../../../../helpers/SiteTitle/SiteTitle";
import WalletSection from "../../../../components/WalletSection/WalletSection";
import FAQSection from "../../../../components/FAQSection/FAQSection";
import { Col, Row } from "./../../../../components/Grid/Grid";
import { convertRoleToPath } from "../../../../utils";
import { dashboardLinks } from "./../../../../utils/data/index";
import { categoryItems, categoryItemsAlias, categoryItemsFarsi, convertCategoryToText } from "../../../../utils/enum";
import { serviceUserContext } from "./../../../../context/UserContext/ServiceUserContext/ServiceUserContext";
import { isEmpty } from "lodash";
import { base_url } from "../../../../services/configServices/config";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";

// Import Swiper styles
import "swiper/css";
import "swiper/css/autoplay";
import Banners from "../../../../components/Banners/Banners";

const ServiceUser = ({ type }) => {

  const findTitle = (model, isTitle) => {
    const newCategories = categoryItemsFarsi.map((key, index) => ({ id: index + 1, type: categoryItems[index], title: key, subtitle: categoryItemsAlias[index] }));
    const findItem = newCategories.find((item, index) => item.type === model)
    if (isTitle) return findItem.title
    return findItem.subtitle
  }

  return (
    <>
      <SiteTitle title={convertCategoryToText(type)} />

      <div className="w-100 d-flex ml-2 mb-3">
        <div className="bg-orange-dim p-1 rounded-pill d-flex p-2" style={{ width: 56, height: 56 }}>
          <img src={`/assets/images/logos/${type}.png`} alt="hotels" />
        </div>
        <div className="flex-grow-1 px-3 justify-around flex-column">
          <p className="text-soft">صفحه اصلی/<span className="fw-bold text-dark"> {findTitle(type, true)}</span></p>
          <h4 className="mt-n4">خدمات {findTitle(type)}</h4>
        </div>
      </div>

      <div className="mb-4">
        <WalletSection wallet={{ type, value: findTitle(type) }} />
      </div>

      <div className="mb-5">
        <ServiceCardSection type={type} />
      </div>

      <Banners />
      <div className="mb-5">
        <FAQSection />
      </div>
    </>
  );
};

export default ServiceUser;

const ServiceCardSection = ({ type }) => {
  const { receptionInfos, handleGetReceptionInfos } =
    useContext(serviceUserContext);

  const [items, setItems] = useState([]);

  const permissions = useSelector((state) => state.permissions);
  const auth = useSelector((state) => state.auth);

  const filterLinks = (menuItems) => {
    return menuItems
      .map((menu) => {
        if (menu.type && menu.type !== type) return null;
        // Todo: fix it
        if (menu.permission && !permissions[menu.permission]) return null;

        if (menu.links) {
          const filteredLink = filterLinks(menu.links);
          menu.links = filteredLink.filter((item) => item !== null);
          return menu.links.length > 0 ? menu : null;
        }

        return menu;
      })
      .filter((menu) => menu !== null);
  };

  useEffect(() => {
    handleGetReceptionInfos();
  }, []);

  useEffect(() => {
    setItems(filterLinks(dashboardLinks));
  }, [permissions]);

  return (
    <>
      <Row className="gy-4">
        {!isEmpty(receptionInfos) && (
          <>
            {receptionInfos?.map((_item) => (
              <Col size="4" md="3" lg="2" className="mb-3" key={_item}>
                <div className="text-center h-100">
                  <Link
                    to={`/${convertRoleToPath(auth.role)}/reception-info/${_item?._id
                      }`}
                    className="d-flex flex-column justify-content-between align-items-between"
                  >
                    <div className="rounded-pill bg-gray-dim p-4">
                      <img
                        src={base_url + _item.avatar}
                        title={_item.title}
                        alt={_item.title}
                        className="img-fluid"
                      />
                    </div>
                    <span className="h6 mt-3">{_item.title}</span>
                  </Link>
                </div>
              </Col>
            ))}
          </>
        )}
        {items.map((item) => (
          <>
            {item.links?.map((_item) => (
              <Col size="4" md="3" lg="2" className="mb-3" key={_item}>
                <div className="text-center h-100">
                  <Link
                    {...(!_item.url && {
                      style: {
                        filter: "grayscale(100%)",
                      },
                    })}
                    to={`/${convertRoleToPath(auth.role)}/${_item?.url}`}
                    className="d-flex flex-column justify-content-between align-items-between"
                  >
                    <div className="rounded-pill bg-gray-dim p-4">
                      <img
                        src={`/assets/images/logos/${_item.logo}`}
                        title={_item.title}
                        alt={_item.title}
                        className="img-fluid"
                      />
                    </div>
                    <span className="h6 mt-3">{_item.title}</span>
                  </Link>
                </div>
              </Col>
            ))}
          </>
        ))}
      </Row>
    </>
  );
};
